import { useTranslation } from 'react-i18next';

import { Box, Button, DialogActions, Typography } from '@mui/material';

import Dialog from '../Dialog';

interface Props {
  open: boolean;
  title?: string;
  messages?: {
    title: string;
    messages: string[];
  }[];
  onSubmit: () => void;
  onCancel: () => void;
}
export default function WarningDialog({
  messages = [],
  onSubmit,
  onCancel,
  open,
  title
}: Props) {
  const { t } = useTranslation('common');

  return (
    <Dialog
      open={open}
      title={title || t('activityPlanning.warning')}
      handleClose={onCancel}
    >
      <Box display="flex" flexDirection="column">
        {messages.map(({ title, messages }, i: number) => {
          return (
            <Box
              key={i}
              marginTop={messages.length > 1 && i !== 0 ? '20px' : 'initial'}
            >
              <Typography variant="body1">{title}</Typography>
              {messages.map((message: string, j: number) => (
                <Typography key={j} variant="body2">
                  • {message}
                </Typography>
              ))}
            </Box>
          );
        })}
      </Box>

      <Box
        sx={{
          marginTop: messages.length > 1 ? '20px' : 'initial'
        }}
      >
        <Typography variant="body1">
          {t('activityPlanning.confirmAction')}
        </Typography>
      </Box>

      <DialogActions className="dialog-actions">
        <Button onClick={onCancel} color="secondary" variant="contained">
          {t('cancel')}
        </Button>
        <Button onClick={onSubmit} color="primary" variant="contained">
          {t('continue')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
